import { EntityDefinition } from '../types/entity-definition.interface';
import { User } from '../types/user.interface';

export const userDefinition: EntityDefinition<User> = {
  entityType: 'User',
  i18nBase: 'entities.user',
  list: {
    columns: [
      {
        field: 'displayName',
        headerKey: 'entities.user.fields.name',
        sortable: true,
        filterable: true,
        class: 'min-w-[200px]',
        contentClass: 'line-clamp-1',
        showTooltip: true,
      },
      {
        field: 'company',
        headerKey: 'entities.user.fields.company',
        sortable: true,
        filterable: true,
        class: 'min-w-[250px]',
        contentClass: 'line-clamp-1',
        showTooltip: true,
      },
      { field: 'isAdmin', headerKey: 'entities.user.fields.isAdmin', sortable: true, filterable: 'checkbox', template: 'boolean' },
      { field: 'active', headerKey: 'entities.user.fields.active', sortable: true, filterable: 'checkbox', template: 'boolean' },
      { field: 'lastLoggedOn', headerKey: 'entities.user.fields.lastLoggedOn', sortable: true, template: 'datetime' },
    ],
  },
  fields: [],
  validationRules: [],
  actionButtons: {
    parent: {},
  },
  formOptions: {
    showDeleteButton: true,
  },
  messages: {
    dialogTitles: {
      create: () => ``,
      edit: () => ``,
      delete: () => ``,
    },
    buttons: {
      add: () => ``,
      create: () => ``,
      edit: () => ``,
      delete: () => ``,
    },
    confirmDelete: () => 'entities.user.messages.deleteConfirm',
  },
  deleteName: entity => entity.displayName,
  enableFiltering: true,
};
